<template>
    <div>
		<div class="form-title">ĐĂNG KÝ</div>
        <form @submit.prevent="registerStep1" class="main-form" ref="overlayWrapper">
          <label for="username">Tên đăng nhập</label>
          <input v-model="username" type="text" id="username" placeholder="Nhập tên đăng nhập" 
		  	v-on:keypress="regex($event)" v-on:keyup="checkInput" v-on:focus="focusField" @copy.prevent @paste.prevent/>
          <small class="warning" v-show="showWarning">
			<img src="@/assets/images/warning.png" alt="" />{{ textWarinng }}
          </small>

        </form>

        <a href="javascript:void(0)" class="btn-next cursor-pointer" :class="{ 'blur': blurBtnNext}" v-on="blurBtnNext ? { } : {click: registerStep1}">Tạo tài khoản</a>

        <div class="form-sign-in" >
			Bạn đã có tài khoản? <a href="javascript:void(0)" @click="$router.push({name: 'username', params: {}})" >Đăng nhập ngay</a>
        </div>
	</div>
</template>
<script>
import { useRegStore } from "@/store";
export default {
	data() {
		const regStore = useRegStore();
		return {
			regStore,
			username: regStore.username || "",
			showWarning: false,
			textWarinng: "Hệ thống đang bận vui lòng thử lại sau",
			blurBtnNext: true,
			serviceId :  this.$route.params.service_id || regStore.serviceId,
		};
	},
	methods: {
		registerStep1() {
			if(this.blurBtnNext){
				return;
			}
			const regStore = useRegStore();
			regStore.username = this.username;
			regStore.signNextStep = "";
			regStore.requestId = "";
			regStore.secureTypeID = 0;
			regStore.secureDataInfo = "";
			let loader = this.$loading.show({
				// Optional parameters
				container: this.$refs.overlayWrapper,
				canCancel: false,
			});
			regStore.checkAccount()
				.then((response) => {
					loader.hide();
					if (response.ResponseCode > 0) {
						this.textWarinng = this.$t(`register.AccountExits`, {}, response.Description);
						this.showWarning = true;
						return;
					}
					if(response.ResponseCode == -50){
						this.showWarning = false;
						this.$router.push({
							name: 'regselectsecure',
							params: {}
						});
						return;
					}
					
					this.textWarinng = "Có lỗi xảy ra khi kiểm tra tài khoản";
					this.showWarning = true;
					return;
				})
				.catch((error) => {
					loader.hide();
					console.error(error);
					this.textWarinng = "Hệ thống đang bận vui lòng thử lại sau";
					this.showWarning = true;
				});
		},
		checkInput(){
			if (this.username.length == 10 ) {
				this.blurBtnNext = false;
				this.textWarinng = "";
				this.showWarning = false;
			}
			else{
				this.blurBtnNext = true;
				this.textWarinng = "Tên đăng nhập có độ dài 10 ký tự số, là số điện thoại Việt Nam bắt đầu bằng số 0";
				this.showWarning = true;
			}
		},
		regex(e) {
			if(e.keyCode == 13) return true;
			let char = String.fromCharCode(e.keyCode); // Get the character
			if(this.username.length == 0 && char == '0') return true;
			let checkSo = /^[0-9]+$/.test(char);
			if(!this.username.startsWith("0") || !checkSo){
				this.textWarinng = "Vui lòng nhập đúng số điện thoại của nhà mạng Việt Nam.";
				this.showWarning = true;
				e.preventDefault();
			}
			else{
				this.textWarinng = "";
				this.showWarning = false;
			}
			
		},
		focusField(){
			this.textWarinng = "Tên đăng nhập có độ dài 10 ký tự số, là số điện thoại Việt Nam bắt đầu bằng số 0";
			this.showWarning = true;
		}
	}
	
};
</script>
<style scoped>

</style>